import * as signalR from "@microsoft/signalr";
import { setDoctorJoined, store, logout, setMaintenance } from "utils/redux-store";
import WebClient, { constants } from "./webclient";
import Swal from "sweetalert2"
import { publish } from "./global-events";
import { setDashboardCounts } from "utils";

class IKhcHub {

    constructor(intl) {
        this.connection = null
        this.intl = intl
    }

    Start() {

        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(`${constants.baseURL}/khcHub`)
            .withAutomaticReconnect({
                nextRetryDelayInMilliseconds: (retryContext) => {
                    if (retryContext.elapsedMilliseconds < 20000) {
                        return Math.random() * 5000;
                    } else {
                        console.error('It takes more than 20 seconds to reconnect the socket.');
                        // setNetworkError(true);
                        return 5000;
                    }
                },
            })
            .configureLogging(signalR.LogLevel.Debug)
            .build();

        this.connection.on("SessionKill", (sessionId) => {

            console.log("SESSION KILL -----> ", sessionId)

            const { member } = store.getState()
            if (sessionId.includes(member?.sessionId)) {
                Swal.fire({
                    title: this.intl.formatMessage({ id: "warning", defaultMessage: "warning" }),
                    text: this.intl.formatMessage({ id: "warning_session_dropped", defaultMessage: "warning_session_dropped" }),
                    icon: "warning",
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.intl.formatMessage({ id: "ok", defaultMessage: "ok" }),
                    cancelButtonText: "",
                    denyButtonText: "",
                    reverseButtons: true,
                    customClass: {
                        confirmButton: 'btn btn-success'
                    },
                    buttonsStyling: false
                }).then((result) => {
                    logout()
                })
            }
        });


        this.connection.on("DashboardChange", (profileId) => {
            console.log("DashboardChange")
            publish("onDashboardRefresh")
        });

        this.connection.on("NewNotificationCountChange", (message) => {
            console.log("NewNotificationCountChange", message)
            setDashboardCounts({ count: message, type: 'notification' });
        });

        this.connection.on("NewBasketItemCountChange", (message) => {
            console.log("NewBasketItemCountChange", message)
            setDashboardCounts({ count: message, type: 'basket' });
        });

        this.connection.on("IsMaintenance", (message) => {
            console.log("IsMaintenance-->", message)
            if (constants.applicationCode == message.code) {
                setMaintenance(message.state)
            }            
        });

        this.connection.on("LoyaltyCardChangePatientStatus", (profileId) => {
            console.log("LoyaltyCardChangePatientStatus")
            publish("onPatientCardInformmationRefresh")
        });

        this.connection.start().then((a) => {
            console.log("Socket Connected", a)
            this.LoginKhcHub()
            //setDashboardCounts({ type: 'all' });
        }).catch((error) => {
        });

        this.connection.onreconnecting(() => {
            console.log("Reconnecting!...")
            // setIsGlobalLoading(true);
        });

        this.connection.onreconnected(() => {
            console.log("Reconnected!...")
            this.LoginKhcHub()
            setDashboardCounts({ type: 'all' });
        })
    }

    Disconnect() {
        this.connection?.stop()
    }

    On(method, callback = () => { }, error = () => { }) {

        if (this.connection?.state == signalR.HubConnectionState.Connected) {
            this.connection.on(method, callback)
        } else {
            error("Socket is not connected!")
        }

    }

    LoginKhcHub = async () => {
        if (this.connection?.state == signalR.HubConnectionState.Connected) {

            console.log("LoginKhcHub", this.connection.connectionId)

            const _state = store.getState()

            await new WebClient().post('5B3C6EB831DD570F8A84/LoginKhcHub', {
                connectionId: this.connection.connectionId,
                requesterType: 1,
                requester: {
                    id: _state.member.profileId,
                    fullName: _state.patient.fullName,
                    userName: "P-" + _state.member.profileId
                }
            });

            this.connection.on("StartPatientAppointmentCallNotLoby", (message) => {
                setDoctorJoined(message)
            })

        }
    }

}

export default IKhcHub